"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommunityProgrammeRequestTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const translation_1 = require("@translation/services/translation");
const user_1 = require("@auth/services/user");
const community_programme_1 = require("@community-programme/services/community-programme");
const loader_1 = require("@common/loader/templates/loader");
const scenario_1 = require("@event/services/scenario");
const type_1 = require("@event/type");
const popup_1 = require("../services/popup");
/**
 * Всплывающее окно
 */
let CommunityProgrammeRequestPopup = class CommunityProgrammeRequestPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = true;
        /**
         * Подтвержденный пользователь
         */
        this.confirmed = false;
        /**
         * Ошибка
         */
        this.error = '';
        /**
         * Промокод
         */
        this.promo = '';
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.userService = typedi_1.Container.get(user_1.UserService);
        this.popupService = typedi_1.Container.get(popup_1.PopupService);
        this.communityProgrammeService = typedi_1.Container.get(community_programme_1.CommunityProgrammeService);
        this.scenarioService = typedi_1.Container.get(scenario_1.ScenarioService);
        this.applyCode = this.applyCode.bind(this);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        setTimeout(() => this.init(), 1000);
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        ${this.loading
            ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}
                                </div>
                            </div>
                        ` : this.error ? (0, lit_html_1.html) `
                            <div>${this.error}</div>    
                        ` : (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <h2>${this.translationService.instant('ec.congratulations')}</h2>
                                <p>${this.translationService.instant('ec.success')}</p>
                                <p>${this.translationService.instant('promotion_your_code')}:<br class="promo-code-br" hidden /> <strong>${this.promo}</strong></p>
                                <p>${this.translationService.instant('third_level_promo_verification_notification')}</p>
                                
                                <button class="btn btn-primary mt-3" @click=${this.applyCode}>${this.translationService.instant('third_level_promo_verification_apply_code')}</button>
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Инициализирует состояние
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { data: { guest, confirmed } } = yield this.userService.info();
                if (guest) {
                    yield this.popupService.open('login', {});
                    this.scenarioService.createScenario([type_1.EventType.USER_AUTHENTICATED, type_1.EventType.MODAL_CLOSED], scenario_1.SCENARIO_TRIGGER_TYPE.ALL, [type_1.EventType.MODAL_CLOSED], () => {
                        this.popupService.open('community-programme-request', {});
                    });
                    return;
                }
                if (!confirmed) {
                    yield this.popupService.open('verification', {});
                    this.scenarioService.createScenario([type_1.EventType.USER_VERIFIED, type_1.EventType.MODAL_CLOSED], scenario_1.SCENARIO_TRIGGER_TYPE.ALL, [type_1.EventType.MODAL_CLOSED], () => {
                        this.popupService.open('community-programme-request', {});
                    });
                    return;
                }
                const { data: { promo } } = yield this.communityProgrammeService.getPromo();
                this.promo = promo;
                this.loading = false;
            }
            catch (err) {
                this.error = err.message;
                this.loading = false;
            }
        });
    }
    /**
     * Применяет код
     */
    applyCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const controller = window.RqPromocode;
            if (!controller) {
                return;
            }
            try {
                yield controller.add(this.promo);
                window.$('.js-promo-field').val(this.promo);
                window.CheckoutPromo.setAppliedState();
                this.popupService.close();
            }
            catch (err) {
                alert(err && err.error || this.translationService.instant('genericerror.title'));
            }
        });
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], CommunityProgrammeRequestPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], CommunityProgrammeRequestPopup.prototype, "confirmed", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", String)
], CommunityProgrammeRequestPopup.prototype, "error", void 0);
CommunityProgrammeRequestPopup = __decorate([
    (0, decorators_js_1.customElement)('art-community-programme-request-popup'),
    __metadata("design:paramtypes", [])
], CommunityProgrammeRequestPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getCommunityProgrammeRequestTemplate() {
    return (0, lit_html_1.html) `<art-community-programme-request-popup></art-community-programme-request-popup>`;
}
exports.getCommunityProgrammeRequestTemplate = getCommunityProgrammeRequestTemplate;
window.PopupController.registerTemplate('community-programme-request', getCommunityProgrammeRequestTemplate);
